import { useTranslation } from 'react-i18next';
import { StyledCols } from '../styles';
import SwitchControl from 'components/Wizards/CustomObject/components/SwitchControl';
import Switch from 'components/Kizen/Switch';
import { getDataQAForInput } from 'components/Inputs/helpers';
import { getToggles } from '../helpers';
import { CO_LAYOUT_ACTION_BLOCK_ACTIONS } from 'components/Wizards/CustomObject/utilities';

const ACTIVITY_KEYS = [
  CO_LAYOUT_ACTION_BLOCK_ACTIONS.SCHEDULE_ACTIVITIES,
  CO_LAYOUT_ACTION_BLOCK_ACTIONS.LOG_ACTIVITIES,
];

export const Actions = ({
  values,
  setValues,
  isContact,
  defaultOnActivities = true,
}) => {
  const { t } = useTranslation();

  const handleChange = (key, checked) =>
    setValues((prev) => ({
      ...prev,
      meta: { ...prev.meta, [key]: checked },
    }));

  return (
    <StyledCols columns={4} gutter="20px">
      {getToggles(t).map(({ key, forContacts, label }) => {
        const isActivityToggle = ACTIVITY_KEYS.includes(key);
        const isDisabled = isActivityToggle && !defaultOnActivities;
        const isChecked = isDisabled ? false : values.meta[key];

        return isContact || !forContacts ? (
          <SwitchControl key={key} label={label}>
            <Switch
              disabled={isDisabled}
              checked={isChecked}
              onChange={(e) => handleChange(key, e.target.checked)}
              {...getDataQAForInput(`action_block_${key}`)}
            />
          </SwitchControl>
        ) : null;
      })}
    </StyledCols>
  );
};
